import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import InfoCardPopup from '../../../../../../InfoCardPopup';

import { timeToShow } from '../../../../../utils/handleTaskTime';
import getToDoAssignmentText from '../../../../../../../utils/getToDoAssigmentText';

const PopupWrapper = ({
  children,
  handleClose,
  task,
  taskId,
  title,
  ...rest
}) => {
  const { formatMessage } = useIntl();

  const { todoTask, completedTime, expiredTime } = task || {};

  const { name, dueDescription } = todoTask || {};

  const headerInfo = timeToShow(
    completedTime,
    expiredTime,
    dueDescription,
    formatMessage,
  );

  return (
    <InfoCardPopup
      title={title}
      onClose={handleClose}
      icon="assigned-task"
      headerTitle={name}
      headerInfo={headerInfo}
      headerSubtitle={getToDoAssignmentText(task, formatMessage)}
      isOpened={Boolean(taskId)}
      style={{ zIndex: 1000 }}
      {...rest}
    >
      {children}
    </InfoCardPopup>
  );
};

PopupWrapper.propTypes = {
  children: PropTypes.node,
  handleClose: PropTypes.func,
  task: PropTypes.object,
  taskId: PropTypes.number,
  title: PropTypes.string,
};

export default PopupWrapper;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/InsuranceToDoTaskPopup/components/common/PopupWrapper/index.jsx